import { createSelector } from 'reselect';
import { denormalize } from 'normalizr';
import QuickbooksOnlineErrorsApi from './Api';
import { EmptyArray, EmptyObject } from '../../EmptyDefaults';
import { getEntities } from '../../EntityData';
import { qboErrorsListSchema, ENTITY_QBO_ERRORS_LIST, QBO_ERRORS_COUNT_NAMESPACE } from '../../../Schema/QuickbooksOnline/ErrorSchema';
import Utils from '../../../components/Common/Utils';
import { onboardingStateSchema } from 'schema/WeaponSchema';

export const ERROR_TYPE_DUPLICATE_INVOICE = 'duplicate_invoice_error';
export const ERROR_TYPE_DUPLICATE_CREDIT_MEMO = 'duplicate_credit_memo_error';
export const ERROR_TYPE_LINKED_CUSTOMER_MATCH = 'linked_customer_match_error';
export const ERROR_TYPE_UNLINKED_CUSTOMER_MATCH = 'unlinked_customer_match_error';
export const ERROR_TYPE_TAX_RATE_MISSING = 'tax_rate_missing_error';
export const ERROR_TYPE_NAME_ALREADY_TAKEN = 'name_already_taken_error';
export const ERROR_TYPE_INVALID_CHARACTER = 'invalid_character_error';
export const ERROR_TYPE_INVALID_SUBSCRIPTION = 'invalid_subscription_error';
export const ERROR_TYPE_NETWORK_ERROR = 'network_error';
export const ERROR_TYPE_SERVER_ERROR = 'server_error';

const DISPLAYABLE_NAME_TAX_RATE_MISSING = 'Tax rate unavailable';
const DISPLAYABLE_NAME_LINKED_CUSTOMER_MATCH = 'Display name conflict';
const DISPLAYABLE_NAME_INVOICE_NUMBER_TAKEN = 'Invoice number already taken';

// TODO: Add urls for each type of specially handled url
export const TYPE_TO_HELP_ARTICLE_MAP = {};

export const PAGE_SIZE = 25;

export const userReadableErrorType = (type) => {
  const errorRemovedType = type.replace('_error', '');
  const spacedType = errorRemovedType.replace(/_/g, ' ');
  return Utils.capitalize(spacedType);
};

export const displayableName = (error) => {
  switch (error.type) {
    case ERROR_TYPE_TAX_RATE_MISSING:
      return DISPLAYABLE_NAME_TAX_RATE_MISSING;
    case ERROR_TYPE_LINKED_CUSTOMER_MATCH:
      return DISPLAYABLE_NAME_LINKED_CUSTOMER_MATCH;
    case ERROR_TYPE_DUPLICATE_INVOICE:
      return DISPLAYABLE_NAME_INVOICE_NUMBER_TAKEN;
    case ERROR_TYPE_DUPLICATE_CREDIT_MEMO:
      return DISPLAYABLE_NAME_INVOICE_NUMBER_TAKEN;
    default:
      return userReadableErrorType(error.type);
  }
};

export const errorHelpLink = (error) => {
  switch (error.type) {
    case ERROR_TYPE_DUPLICATE_INVOICE:
      return 'https://help.housecallpro.com/en/articles/5229371-duplicate-invoice-error';
    default:
      return undefined;
  }
};
export const quickbooksOnlineError = (error) => error.response.data.quickbooks_online_error;
export const repairContext = (error) => error.response.data.repair_context;

export const getQboErrorsPaginationData = createSelector(
  getEntities,
  (entities) => entities[ENTITY_QBO_ERRORS_LIST]?.list || EmptyObject
);

export const getQboErrors = createSelector(getEntities, (entities) => {
  if (entities[ENTITY_QBO_ERRORS_LIST]?.list) {
    return denormalize('list', qboErrorsListSchema, entities).data;
  }
  return EmptyArray;
});

export const fetchQboErrors = ({ filters = {}, page = 0, pageSize = PAGE_SIZE, sortBy, sortDirection }) => ({
  fetchingApiFunc: QuickbooksOnlineErrorsApi.index,
  selector: getQboErrors,
  paramsFromProps: () => [
    {
      page,
      pageSize,
      filters,
      sortBy,
      sortDirection,
    },
  ],
  schema: qboErrorsListSchema,
  alwaysFetch: true,
});

export const getQboErrorsCount = createSelector(
  (state) => state[QBO_ERRORS_COUNT_NAMESPACE],
  (qboErrors) => {
    return qboErrors?.total_count || 0
  }
);

export const fetchQboErrorsCount = () => ({
  fetchingApiFunc: QuickbooksOnlineErrorsApi.index,
  selector: getQboErrorsCount,
  paramsFromProps: () => [
    {
      page: 0,
      pageSize: 1,
    },
  ],
  dataNamespace: QBO_ERRORS_COUNT_NAMESPACE,
  alwaysFetch: true,
});
